import { Box, Flex } from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";
import useIsMobile from "../../hooks/useIsMobile";

const SidePanel = ({ open, close, children, isTop, w }) => {
  const isMobile = useIsMobile();

  return (
    <>
      <AnimatePresence>
        {open && (
          <>
            <Box
              as={motion.div}
              position="fixed"
              h="calc(100vh + 30px)"
              w={isTop ? "calc(100vw + 6px)" : "calc(100vw + 1px)"}
              top={isTop ? "-16px" : "-30px"}
              left={isTop ? "-276px" : "0px"}
              background="rgba(0, 0, 0, 0.4)"
              zIndex="1001"
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
                transition: {
                  duration: 0.2,
                },
              }}
              exit={{
                opacity: 0,
                transition: {
                  duration: 0.1,
                },
              }}
              onClick={close}
            />
            <Box
              as={motion.div}
              position="fixed"
              w={w}
              m={isTop ? "0 auto" : "auto"}
              top="0"
              right="1rem"
              bottom="0"
              zIndex="1002"
              h={isTop ? "calc(100vh - 33px)" : "calc(100vh - 60px)"}
              borderRadius="2rem"
              overflow="hidden"
              initial={{
                scale: 1,
                x: "100vw",
              }}
              animate={{
                scale: 1,
                x: 0,
                transition: {
                  duration: 0.2,
                },
              }}
              exit={{
                scale: 0,
                x: "100vw",
                transition: {
                  duration: 0.1,
                },
              }}
            >
              <Box
                as={motion.div}
                w="100%"
                p="0 0rem"
                h="100%"

                // initial={{
                //   opacity: 0,
                //   x: 100,
                // }}
                // animate={{
                //   opacity: 1,
                //   x: 0,
                //   transition: {
                //     delay: 0.3,
                //   },
                // }}
                // exit={{
                //   opacity: 0,
                //   transition: {
                //     duration: 0.1,
                //   },
                // }}
                // className="modal-content"
              >
                <Flex w="100%" h="100%" justify="flex-end">
                  {children}
                </Flex>
              </Box>
            </Box>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default SidePanel;
